module.exports = __webpack_public_path__ + "static/logo-google-6292a313e6d116f8ea74c3f3565c18c2.png";